import { useCallback } from 'react';
import { useBuildVars } from '../config';
import { getSameOriginApiBasePath, useSameOriginApis } from './utils';

export function useApiBase() {
  const buildVars = useBuildVars();
  const shouldUseSameOriginApis = useSameOriginApis();

  // Extract individual values to avoid object reference changes
  const API_BASE = buildVars.API_BASE;

  return useCallback(
    (route: string) => {
      if (route?.toLowerCase().startsWith('http')) {
        return '';
      }
      if (shouldUseSameOriginApis()) {
        return getSameOriginApiBasePath();
      }

      return API_BASE;
    },
    [shouldUseSameOriginApis, API_BASE]
  );
}
